import * as React from 'react';

import { CalendarActions, ICalendarState } from '@adage/ace-calendar';
import { IArenaEvent } from '../classes/event';
import { connect } from 'react-redux';


import { IOption } from '../../classes/index';
import AccessibilityItem from '../components/accessibility-item';
import { JumpToFirstEventMonth } from '../calendar-helpers'


interface AccessibilitySelectionState {
    wheelchairSeating: boolean;
    openCaptioned: boolean;
    audioDescribed: boolean;
    postShowDiscussion: boolean;
    bestValue: boolean
}

interface ClearingProps {
    shouldClear: boolean;
    isMobile: boolean;
}

export class AccessibilitySelection extends React.Component<ClearingProps, AccessibilitySelectionState> {
    constructor(props) {
        super(props);

        this.state = {
            wheelchairSeating: false,
            openCaptioned: false,
            audioDescribed: false,
            postShowDiscussion: false,
            bestValue: false
        };
    }

    componentWillReceiveProps(props: ClearingProps) {
        if (props.shouldClear != this.props.shouldClear) {
            this.setState({ wheelchairSeating: false, openCaptioned: false, audioDescribed: false, postShowDiscussion: false, bestValue: false });
        }
    }

    private filter(event: IArenaEvent) {
        var isMatch = false;

        if (this.state.wheelchairSeating == false && this.state.audioDescribed == false && this.state.openCaptioned == false && this.state.postShowDiscussion == false && this.state.bestValue == false) {
            isMatch = true;
        }

        if (this.state.wheelchairSeating && event.wheelchairSeating) {
            isMatch = true;
        }

        if (this.state.openCaptioned && event.openCaptioned) {
            isMatch = true;
        }

        if (this.state.audioDescribed && event.audioDescribed) {
            isMatch = true;
        }

        if (this.state.postShowDiscussion && event.postShowDiscussion) {
            isMatch = true;
        }

        if (this.state.bestValue && event.bestValue) {
            isMatch = true;
        }

        return isMatch;
    }

    private filterBind = this.filter.bind(this)
    private boundCheckboxChange = this.checkboxChange.bind(this)

    checkboxChange(accessibility: string, value: boolean) {
        switch (accessibility) {
            case "wheelchair":
                this.setState({ wheelchairSeating: value });
                break;
            case "openCaptioned":
                this.setState({ openCaptioned: value });
                break;
            case "audioDescribed":
                this.setState({ audioDescribed: value });
                break;
            case "postShowDiscussion":
                this.setState({ postShowDiscussion: value });
                break;
            case "bestValue":
                this.setState({ bestValue: value });
                break;
        }

        CalendarActions.updateEventFilter({
            key: "accessibility",
            filter: this.filterBind
        })

        if (value) {
            JumpToFirstEventMonth.bind(this)(this.props.isMobile);
        }
    }

    render() {
        return (
            <div className="cal-filters-accessibility-container">
                <h2 className="cal-filters-accessibility-title">Accessibility & Extras</h2>
                <ul>
                    <li>
                        <AccessibilityItem onChange={this.boundCheckboxChange} accessibilityText={"Wheelchair seating"} id="wheelchair" svgId="#icon-wheelchair" shouldClear={this.props.shouldClear} />
                    </li>

                    <li>
                        <AccessibilityItem accessibilityText="Open Captioned" onChange={this.boundCheckboxChange} id="openCaptioned" svgId="#icon-open-captioned" shouldClear={this.props.shouldClear} />
                    </li>

                    <li>
                        <AccessibilityItem accessibilityText="Audio Described" onChange={this.boundCheckboxChange} id="audioDescribed" svgId="#icon-audio-described" shouldClear={this.props.shouldClear} />
                    </li>

                    <li>
                        <AccessibilityItem accessibilityText="Post-Show Discussion" onChange={this.boundCheckboxChange} id="postShowDiscussion" svgId="#icon-post-show-discussion" shouldClear={this.props.shouldClear} />
                    </li>
                    <li>
                        <AccessibilityItem accessibilityText="Best Value" onChange={this.boundCheckboxChange} id="bestValue" svgId="#icon-best-value" shouldClear={this.props.shouldClear} />
                    </li>
                </ul>
            </div>
        );
    }
}

export default (AccessibilitySelection);


// WEBPACK FOOTER //
// ./app/calendar/components/accessibility-selection.tsx